export default __webpack_public_path__ + "static/media/failedpicture.86866884.png";